/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

Vue.use(Vuex)

import moduleCalendar from './calendar/moduleCalendar'


const vuexPersist = new VuexPersist({
  key: 'persistedData',
  storage: localStorage
})

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  plugins: [vuexPersist.plugin],
  modules: {
    calendar: moduleCalendar
  },
  strict: process.env.NODE_ENV !== 'production'
})
